import { render, staticRenderFns } from "./exchange-gift-detail.vue?vue&type=template&id=69af301b"
import script from "./exchange-gift-detail.vue?vue&type=script&lang=js"
export * from "./exchange-gift-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports